// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2P4me","filesListContainer":"PosDisputesFiles_filesListContainer__2nJyP","filesButton":"PosDisputesFiles_filesButton__9_l-O"};